import { calculateCompoundRewards } from '../utils'

const CURRENCY_APY_RATES = {
  USDC: 3.75,
  USDG: 5.75,
}

export const useCalculateRewards = (amount: number, currency: string) => {
  const apy = CURRENCY_APY_RATES[currency]
  const rewardsData = calculateCompoundRewards(amount, apy)

  return {
    rewardsData,
  }
}
